module.exports = __webpack_public_path__ + "img/icons_21.2dc156f8.png";